import { styled } from '@styles'

export const Row = styled.div`
  display: flex;
  margin-top: 0.8rem;
`
